import BookList from '../components/BookList';
import Form from '../components/Form';

function Home() {
  return (
    <>
      <BookList />
      <Form />
    </>
  );
}

export default Home;
